export const SHELL_HISTORY_COOKIE = "lattice_shell_history";

const SHELL_HISTORY_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

export function parseShellHistoryPreference(
  value: string | undefined,
): boolean {
  if (value === "closed") return false;
  return true;
}

export function serializeShellHistoryPreference(open: boolean): string {
  return [
    `${SHELL_HISTORY_COOKIE}=${open ? "open" : "closed"}`,
    "Path=/app/shell",
    `Max-Age=${SHELL_HISTORY_COOKIE_MAX_AGE_SECONDS}`,
    "SameSite=Lax",
  ].join("; ");
}

export function persistShellHistoryPreference(open: boolean): void {
  document.cookie = serializeShellHistoryPreference(open);
}

type T_HeaderReader = {
  get: (name: string) => string | null;
};

/** Request-time device hint for the initial shell render. Client matchMedia
 * remains authoritative after hydration and handles resized desktop windows. */
export function isMobileShellRequest(headers: T_HeaderReader): boolean {
  const clientHint = headers.get("sec-ch-ua-mobile");
  if (clientHint === "?1") return true;
  if (clientHint === "?0") return false;

  const userAgent = headers.get("user-agent") ?? "";
  return /Android.+Mobile|iPhone|iPod|Mobile Safari/i.test(userAgent);
}
